import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { WorkOrderService } from "../../../services/index";

@Component({
  selector: "cutting-plan-print",
  templateUrl: "./cuttingPlanPrint.html",
})
export class cuttingPlanPrint implements OnInit {
  @Output() partyUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  mode: string;
  @Input() partydata: any = [];
  partyList: any = [];
  list: any = [];
  agentList: any = [];
  designList: any = [];
  printdata: any = {};
  woGrTot: number = 0.0;
  woGrTotMtr: number = 0;
  wodata: any = {};
  dataList: any = [];
  woDetails: any;
  alphabet: string[];
  predefCol: number;
  userDefCol: number;
  cuttingRatio: number;
  woCons: number;
  maxColor: number;
  @Input() set printdt(val: any[]) {
    this.printdata = val;
    console.log(this.printdata);
    this.getDesignList(this.printdata.cu_no, this.printdata.cp_date);
  }

  isLoading: boolean = false;
  @ViewChild("partyForm") partyForm;
  orderfromdtControl: FormControl = new FormControl();
  ordertodtControl: FormControl = new FormControl();
  salesfromdtControl: FormControl = new FormControl();
  salestodtControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    private woservice: WorkOrderService,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService,
    public datePipe: DatePipe
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
    }, 100);
  }

  getDesignList(cu_no, cp_date) {
    let params = {
      cu_no: cu_no,
      cp_date: cp_date,
    };
    let that = this;
    that.woservice.getCuttingPlanPrint(params).then((res: any) => {
      /*   res.data = res.data.concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data).concat(res.data);  */
      that.dataList = res.data;
      that.woDetails = res.woDetails;
      that.dataList[0].cp_date = this.datePipe.transform(
        that.dataList[0].cp_date,
        "dd-MM-yyyy"
      );
      that.woDetails.forEach((element) => {
        that.woGrTot += element.grTot;
      });

      that.woDetails.forEach((element) => {
        that.woGrTotMtr += element.grTotMtr;
      });

      that.woGrTotMtr = Number(that.woGrTotMtr.toFixed(2));

      that.cuttingRatio = that.dataList[0].cutting_ratio;
      that.woCons = Number((that.woGrTotMtr / that.woGrTot).toFixed(2));
      that.maxColor = Math.max.apply(
        Math,
        that.woDetails.map(function (o) {
          return o.maxColor;
        })
      );
      that.alphabet = Array.from(Array(that.maxColor + 1), (e, i) =>
        String.fromCharCode(i + 65)
      );
      that.predefCol = (that.maxColor + 1 - 2) * 2 + 2;
      that.userDefCol = that.maxColor + 1 - 2 + 2;

      console.log(that.alphabet);
    });
  }

  toFixNumber(num) {
    return Number(num).toFixed(2);
  }

  print(div) {
    var content = document.getElementById(div).innerHTML;

    var mywindow = window.open("", "Print", "height=850,width=1000");

    /*mywindow.document.write('<html><head><title>Print</title>');
    mywindow.document.write('</head><body >');*/
    mywindow.document.write(content);
    //   mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/cuttingPlanPrint.ts